import { AxiosError } from 'axios';
import { NullAble } from 'data/base';

export const asAxiosError = (e: NullAble<Error>): AxiosError | undefined => {
  const axiosError: AxiosError = (e as unknown) as AxiosError;
  if (axiosError.isAxiosError) {
    return axiosError;
  } else {
    return undefined;
  }
};
